import React from 'react'
import Button from '@mui/material/Button'

type Props = {
  onClick?: () => void
}

// Shared by the badge and entity bubbles so they cannot drift in label or styling.
// Pass via StatusSection's viewHistoryButton slot, never alongside it: the slot puts the
// link inside the knock status card and inherits its D2D gate.
export function ViewKnockStatusHistoryButton({ onClick }: Props) {
  return (
    <Button
      variant="text"
      size="small"
      onClick={onClick}
      sx={{
        alignSelf: 'flex-start',
        color: '#1565C0',
        minWidth: 0,
        textTransform: 'none',
      }}
    >
      View Knock Status History
    </Button>
  )
}
